import { render } from "./EditSectionHead.vue?vue&type=template&id=edd746f4"
import script from "./EditSectionHead.vue?vue&type=script&lang=js"
export * from "./EditSectionHead.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__